import React, { useContext, useEffect, Component } from 'react'
import { authContext } from '../../Login/AuthContext';
import Checkboxs from '../Ventilation/Checkbox'
import { Link } from 'react-router-dom'

var zones = [];

const ComposeArea = () => {
  const { auth } = useContext(authContext);

  useEffect(() => {
    if (auth.data.zones)
      zones = auth.data.zones;
  }, [auth.data])

  if(auth.data.GADM36Level !== "0")
    return;
  return (
    <>
        <div className="alert alert-primary" role="alert" key="areas_clickingBar">Composer une zone géographique</div>
        <SearchBox/>
    </>
  )}

export default ComposeArea;

class SearchBox extends Component {
  state = {
    results : [],
    level:5,
    name:"",
    selected:[]
  };
  static contextType = authContext;

  useEffect = () => {
    if(!this.context.auth.data.selectedZones)
      this.setState({choice:[]})
    else
      this.setState({choice:this.context.auth.data.selectedZones})
  }

  handleInputChange = event => {
    if(!zones)
      return;
      this.setState({name:event.target.value})
    this.search (event.target.value, this.state.level);
  }

    handleSelectChange = event => {
        event.preventDefault();
        this.setState({level:event.target.value})
        this.search (this.state.name, event.target.value);
    }

    search = (name, level) => {
        var result = [];
        fetch("https://mel.dvrc.fr/api/GetGadm36Zone.php?name="+name+"&level="+level+"&token="+this.context.auth.data.token)
        .then(res => res.json())
        .then( (data) => {
            if(Array.isArray(data)){
                data.map((zone,i) => {
                    result.push(zone);
                    return 1;
                })
            }
            this.setState({results:result})
      })
    }

  addZone = elem =>{
    this.state.selected.push(this.state.results[elem.target.value])
    this.setState({selected:this.state.selected})
    this.changeZone()
  }

  removeZone = elem =>{
    this.state.selected.splice(elem.target.value, 1)
    this.setState({selected:this.state.selected})
    this.changeZone()
  }

  changeZone = () => {
    var list = "";
    var i=0;
    this.state.selected.map((elem, i) => {
        if(i==0)
            list+=elem.gid;
        else
            list+=","+elem.gid;
    });
    this.context.auth.data.zone = {name:"Ma zone", shapes:list, Zone:"FRA"};
    this.context.setAuthData(this.context.auth.data)
  }

  render () {
    return (
      <div className="row" id="select_areas">
        <div key="SearchBox" className="col">
          <form>
            <label>
                <b>Recherche</b> <input type="text" id="filter" placeholder="Nom de la zone..."  onChange={this.handleInputChange}/>
                <select name="levelId" defaultValue={5} onChange={this.handleSelectChange}>
                    <option value={1}>Région</option>
                    <option value={2}>Département</option>
                    <option value={3}>Canton</option>
                    <option value={4}>Ville</option>
                    <option value={5}>Commune</option>
                </select>
            </label>
          </form>
          <table>
            <thead className="thead-dark"><tr><td>Région</td><td>Département</td><td>Canton</td><td>Ville</td><td>Commune</td></tr></thead>
            <tbody>
            {this.state.results.map((elem, i) =>
              <tr key={"search_"+i}>
                <td>{elem.name_1}</td>
                <td>{elem.name_2}</td>
                <td>{elem.name_3}</td>
                <td>{elem.name_4}</td>
                <td>{elem.name_5}</td>
                <td><button onClick={this.addZone} value={i}>+</button></td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
        <div key="selectedZones" className="col">
          <Link to="/Booking/Ventilation" onClick={() => {}}>Valider ce périmètre d'étude</Link>
          <table>
            <thead className="thead-dark"><tr><td>Gid</td><td>Ville</td><td>Commune</td></tr></thead>
            <tbody>
                {this.state.selected.map((elem, i) =>
                  <tr key={"selected_"+i}>
                    <td>{elem.gid}</td>
                    <td>{elem.name_4}</td>
                    <td>{elem.name_5}</td>
                    <td><button onClick={this.removeZone} value={i}>-</button></td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
/*
<h3>Selected Areas</h3>
<ul>
  {this.context.auth.data.selectedZones.map((elem, i) =>
    <li key={"choice_"+i}>{elem.name} <button onClick={this.removeZone} value={i}>-</button></li>
  )}
</ul>
*/
